import { sendEvent } from '@civitime/game-server/lib/saga-tools/Data.effects'
import { bots }      from '@civitime/game-server/lib/Helpers-shared/bots'
import { shuffle }   from '@civitime/game-server/lib/Domain/Content/Content.helpers'

export function * getBotsToChallenge (command) {
  const selectedBots = shuffle(bots).slice(0, 3)
  yield sendEvent('BotsToChallengeGet', { bots: selectedBots })
}